// src/views/TermsPage.jsx - VERSION CORRIGÉE (HTML direct)
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PublicTopBar from "./PublicTopBar";
import Footer from "../components/Footer";
import { publicSiteWebService } from "../services/publicSiteWebService";

export default function TermsPage() {
  const [loading, setLoading] = useState(true);
  const [documentData, setDocumentData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await publicSiteWebService.getDocumentLegal('cgu');
        setDocumentData(data);
      } catch (err) {
        setDocumentData(null);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="terms-page">
        <PublicTopBar />
        <div className="loader-container">
          <div className="loader-spinner" />
        </div>
        <Footer />
        <style>{`
          .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }
          .loader-spinner { width: 48px; height: 48px; border: 4px solid #e2e8f0; border-top-color: #004080; border-radius: 50%; animation: spin 0.8s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  const content = documentData?.contenu || "";
  const version = documentData?.version || "1.0";
  const datePub = documentData?.date_publication 
    ? new Date(documentData.date_publication).toLocaleDateString("fr-FR", {
        day: "2-digit", month: "2-digit", year: "numeric"
      })
    : "Date inconnue";

  return (
    <>
      <style>{`
        :root {
          --n-bg: #f8f9fa;
          --n-card: #ffffff;
          --n-ink: #0f1b2d;
          --n-mut: #64748b;
          --n-b: #e8e8ee;
          --n-b2: #d0d0da;
          --pr: #004080;
          --pr-lt: #0066CC;
          --pr-bg: #e6eef7;
        }

        .terms-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: var(--n-bg);
        }

        .terms-hero {
          flex: 1;
          padding: 120px 20px 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .terms-content {
          max-width: 900px;
          width: 100%;
          animation: fadeInUp 0.6s ease;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .terms-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .terms-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: var(--pr-bg);
          color: var(--pr);
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .terms-badge i { font-size: 17px; }

        .terms-title {
          font-size: 38px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 8px;
          line-height: 1.2;
        }

        .terms-title span { color: var(--pr); }

        .terms-meta {
          font-size: 14px;
          color: var(--n-mut);
          margin: 0 0 20px;
        }

        .terms-meta span { margin: 0 8px; }

        .terms-divider {
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, var(--pr), var(--pr-lt));
          border-radius: 2px;
          margin: 0 auto 20px;
        }

        .terms-body {
          background: var(--n-card);
          border: 1px solid var(--n-b);
          border-radius: 16px;
          padding: 40px 48px;
          margin-bottom: 28px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        }

        .terms-body h1 {
          font-size: 28px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 16px;
        }

        .terms-body h2 {
          font-size: 22px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 28px 0 12px;
          padding-bottom: 8px;
          border-bottom: 2px solid var(--pr-bg);
        }

        .terms-body h3 {
          font-size: 18px;
          font-weight: 600;
          color: var(--n-ink);
          margin: 20px 0 10px;
        }

        .terms-body p {
          font-size: 15px;
          line-height: 1.8;
          color: var(--n-ink);
          margin: 0 0 12px;
        }

        .terms-body ul {
          padding-left: 24px;
          margin: 8px 0 16px;
        }

        .terms-body li {
          font-size: 15px;
          line-height: 1.7;
          color: var(--n-ink);
          margin-bottom: 6px;
        }

        .terms-body strong {
          color: var(--pr);
        }

        .terms-body hr {
          margin: 24px 0;
          border: none;
          border-top: 1px solid var(--n-b);
        }

        .terms-empty {
          text-align: center;
          padding: 60px 20px;
          color: var(--n-mut);
          font-size: 15px;
        }

        .terms-empty i {
          font-size: 32px;
          display: block;
          margin-bottom: 8px;
        }

        .terms-actions {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .terms-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: var(--pr);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px 28px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .terms-cta:hover {
          background: var(--pr-lt);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0, 64, 128, 0.3);
        }

        .terms-cta i { font-size: 17px; }

        .terms-cta-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          color: var(--pr);
          border: 2px solid var(--pr);
          border-radius: 12px;
          padding: 12px 26px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .terms-cta-secondary:hover {
          background: var(--pr);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0,64,128,0.15);
        }

        .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }

        .loader-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #e2e8f0;
          border-top-color: #004080;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @media (max-width: 768px) {
          .terms-title { font-size: 30px; }
          .terms-hero { padding: 100px 16px 30px; }
          .terms-body { padding: 24px 20px; }
        }

        @media (max-width: 480px) {
          .terms-title { font-size: 24px; }
          .terms-hero { padding: 90px 16px 20px; }
          .terms-body { padding: 16px; }
          .terms-body h1 { font-size: 22px; }
          .terms-body h2 { font-size: 18px; }
          .terms-body p, .terms-body li { font-size: 14px; }
          .terms-cta, .terms-cta-secondary { width: 100%; justify-content: center; }
        }
      `}</style>

      <div className="terms-page">
        <PublicTopBar />

        <section className="terms-hero">
          <div className="terms-content">
            <div className="terms-header">
              <div className="terms-badge">
                <i className="ti ti-file-contract"></i>
                <span>Conditions</span>
              </div>

              <h1 className="terms-title">
                Conditions d'<span>Utilisation</span>
              </h1>

              <p className="terms-meta">
                Version {version} <span>•</span> Mise à jour le {datePub}
              </p>

              <div className="terms-divider"></div>
            </div>

            <div className="terms-body">
              {content ? (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                <div className="terms-empty">
                  <i className="ti ti-file-off"></i>
                  Le contenu de cette page n'est pas encore disponible.
                </div>
              )}
            </div>

            <div className="terms-actions">
              <Link to="/" className="terms-cta">
                <i className="ti ti-arrow-left" aria-hidden="true"></i>
                Retour à l'accueil
              </Link>
              <Link to="/contact" className="terms-cta-secondary">
                <i className="ti ti-message-circle"></i>
                Nous contacter
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}